import React from 'react';
import {useTranslation} from 'react-i18next';

import type {ButtonProps} from '@pexip/components';
import {Button, onEnter} from '@pexip/components';

import {TestId} from '../../../test/testIds';

export const JoinMeetingButton: React.FC<
    ButtonProps & {
        isDisabled?: boolean;
        onClick: () => void;
    }
> = ({isDisabled, onClick, className}) => {
    const {t} = useTranslation();

    return (
        <Button
            className={className}
            isDisabled={isDisabled}
            onClick={onClick}
            onKeyDown={onEnter(onClick)}
            size="large"
            type="submit"
            variant="success"
            modifier="fullWidth"
            data-testid={TestId.ButtonJoinMeeting}
        >
            {t('common.join-now', 'Join now')}
        </Button>
    );
};
